import { AccordionSummary, AccordionSummaryProps, Button, ButtonProps } from '@mui/material';

export const FormAccordionSummary = (props: AccordionSummaryProps): React.JSX.Element => (
  <AccordionSummary
    sx={{
      minHeight: 46,
      content: { margin: '16px 0 8px 0 !important' },
      expandIcon: { marginTop: 4 },
    }}
  >
    {props.children}
  </AccordionSummary>
);

export const FormButton = (props: ButtonProps): React.JSX.Element => (
  <Button
    sx={{
      flexGrow: 1,
      m: 2,
    }}
    {...props}
  >
    {props.children}
  </Button>
);
